export default function exposeAsGlobal(objectName: string, obj: any): void {
  if (process.env.REACT_APP_ENV !== 'live') {
    (window as any)[objectName] = obj;
  }
}
